module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Editor', {
    ref: "editorSubmission",
    attrs: {
      "id": "editor",
      "init": _vm.editor_options,
      "value": _vm.content
    },
    on: {
      "onInit": _vm.setInitialContent,
      "onKeyUp": _vm.changeContent,
      "onChange": _vm.changeContent,
      "onObjectResized": _vm.changeContent,
      "onExecCommand": _vm.changeContent
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-44e2fa72!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/textEditor/tinymce.vue
// module id = 1286
// module chunks = 61